import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AppointmentParticipantDetail } from "../../Components/Appointments/appointmentParticipantTypes";

export interface Slot {
  id: string;
  appointmentId: string | null;
  startDateTime: Date;
  endDateTime: Date;
  time: string;
  date: string;
  timezone?: string;
  roomTime?: string;
  roomDate?: string;
  timeZoneLabel?: string;
  status: number;
  roomId?: string;
  appointment?: {
    id: string;
    studyId: string;
    inviters: { id: string; name: string }[];
    invitees: AppointmentParticipantDetail[];
    study: string;
    notes: string;
    status: string;
    roomName?: string;
  };
}

export interface Room {
  id: string;
  name: string;
}

export interface Site {
  id: string;
  name: string;
  timezone: string;
  timezoneLabel: string;
  rooms: Room[];
}

export interface AppointmentSlice {
  selectedIds: string[];
  selectedSite: Site | null;
  selectedRoom: Room | null;
}

const initialState: AppointmentSlice = {
  selectedIds: [],
  selectedSite: null,
  selectedRoom: null,
};

export const appointmentSlice = createSlice({
  name: "appointment",
  initialState: initialState,
  reducers: {
    setSelectedIds: (state, action: PayloadAction<string[]>) => {
      state.selectedIds = action.payload;
    },
    addOrRemoveId: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const index = state.selectedIds.indexOf(id);
      if (index > -1) {
        state.selectedIds.splice(index, 1);
      } else {
        state.selectedIds.push(id);
      }
    },
    setSelectedSite: (state, action: PayloadAction<Site | null>) => {
      state.selectedSite = action.payload;
    },
    setSelectedRoom: (state, action: PayloadAction<Room | null>) => {
      state.selectedRoom = action.payload;
    },
  },
});

export const {
  setSelectedIds,
  addOrRemoveId,
  setSelectedSite,
  setSelectedRoom,
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
